import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-bayauc-auction',
  templateUrl: './bayauc-auction.component.html',
  styleUrls: ['./bayauc-auction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BayaucAuctionComponent {
  @Input() lang = 'ru';
}
